import { combineReducers } from 'redux';
import auth from './auth/reducer';
import user from './user/reducer';
import trainingRoutine from './training-routine/reducer';

export default combineReducers({ auth, user, trainingRoutine });
